module.exports = __webpack_public_path__ + "img/icon-doc.85cfb3aa.svg";